import * as React from 'react';
import { Grid } from '../../../../../../ui-toolkit';
import { IPresentationCdItems } from '../../../../../../store/order/cdBuilder';
import { IUnderwriterRemittanceResponse } from '../../../../../../types/order/escrow/IUnderwriterRemittanceResponse';
import { RevenueCalculation } from './RevenueCalculation';
import { AmericanDigitalDisclaimer } from './AmericanDigitalDisclaimer';
import { IParty } from '../../../../../../ui-toolkit/orders/interfaces/IParty';

export interface ILoadingSectionProps {
  orderId: string;
  isSprucePowered: boolean;
  parties: IParty[];
  cdItems?: { [p: string]: IPresentationCdItems };
  remittances: IUnderwriterRemittanceResponse[];
}

export const LoadingSection: React.FC<ILoadingSectionProps> = ({
  orderId,
  parties,
  cdItems,
  remittances,
  isSprucePowered,
}) => (
  <Grid>
    <AmericanDigitalDisclaimer parties={parties} />
    {cdItems && !!remittances.length && (
      <RevenueCalculation
        cdItems={cdItems!![orderId].items.asArray || []}
        underwriterRemittances={remittances!!}
        isSprucePowered={isSprucePowered}
      />
    )}
  </Grid>
);
